<template>
    <div class="page-block__item-wrapper">
        <h3>{{ trans('domain.dns.title') }}</h3>

        <domain-nameservers
            v-if="nameservers"
            :domain="domain"
            :nameservers="nameservers"
            :nameservergroup="nameservergroup"
        />

        <domain-dnssec :domain="domain" :dnssecKeys="dnssecKeys" />
    </div>
</template>

<script>
import DomainNameservers from './DomainNameservers.vue';
import DomainDnssec from './DomainDnssec.vue';

export default {
    components: {
        DomainNameservers,
        DomainDnssec
    },
    props: {
        nameservers: {
            type: Array,
            default: null
        },
        dnssecKeys: {
            type: Array,
            default: () => []
        },
        nameservergroup: {
            type: String,
            default: null
        },
        domain: {
            type: String,
            required: true
        }
    }
};
</script>
